var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.596 5.84c-.439.436-.862.857-1.279 1.278-.03.03-.044.1-.033.144.1.561.163 1.123.115 1.692-.052.613-.212 1.185-.654 1.65-.163.17-.36.2-.561.075a.918.918 0 01-.16-.133c-.773-.765-1.542-1.533-2.311-2.298-.045-.044-.082-.1-.123-.151-.022-.008-.04-.015-.063-.019-.026.045-.041.1-.078.133-.877.876-1.758 1.747-2.635 2.623A.508.508 0 01.405 11a.4.4 0 01-.357-.225.397.397 0 01.026-.433.956.956 0 01.13-.144c.874-.868 1.747-1.736 2.62-2.6.038-.037.071-.074.142-.148-.052-.033-.108-.055-.149-.092-.784-.776-1.568-1.555-2.352-2.335-.272-.27-.268-.502.015-.753.397-.35.873-.51 1.39-.573.635-.08 1.267-.022 1.895.093.052.01.126 0 .16-.033A205.9 205.9 0 005.21 2.486c-.093-.092-.182-.185-.271-.273-.234-.237-.234-.462 0-.695L6.288.178c.23-.23.464-.233.695-.004C8.269 1.452 9.55 2.734 10.844 4c.197.192.22.669-.004.872-.438.395-.843.827-1.263 1.245-.234.233-.465.233-.703.004l-.278-.281z",
    fill: "#002B38"
  })));
}

export default SvgPin;